import { useEffect, useState } from 'react'
import { useMutate } from 'restful-react'
import { euCountryCodes } from './Constants'

export default function useGdprCompliance() {
    const { mutate: getMyIpInfo, error: getMyIpInfoError } = useMutate({
        verb: 'POST',
        path: `/v1/requests/ip-info`,
    })

    const [countryCode, setCountryCode] = useState<string | null>(null)

    const queryShouldBeGdprCompliant = async () => {
        const response = await getMyIpInfo({})
        if (response && response.countryCode) {
            setCountryCode(response.countryCode)
            if (euCountryCodes.includes(response.countryCode)) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    useEffect(() => {
        if (getMyIpInfoError) {
        }
    }, [getMyIpInfoError])

    return {
        queryShouldBeGdprCompliant,
        countryCode,
    }
}
